Namespace 'Monitoring.Views.Dashboards'

class Monitoring.Views.Dashboards.TagsHierarchyView extends Backbone.View
  template: JST['backbone/templates/monitoring/social_contents/tags_editor/tags_hierarchy']
  className: 'tags-hierarchy-container'

  events:
    'click .tags-hierarchy-close': '_closeModal'
    'click .tags-hierarchy-accept': '_submitSelection'
    'change #taxonomy-select-input': 'onChangeSelectedTaxonomy'

  initialize: ({currentTags, translator, firstLevelNodes, includeAlternativeTaxonomies=Keepcon.currentAccount.includeAlternativeTaxonomies}) ->
    @currentTags = currentTags
    @translator = translator
    @formattedNodes = @_formattedNodes firstLevelNodes
    @taxonomiesRepository = new Monitoring.Models.TaxonomiesRepository
    @includeAlternativeTaxonomies = includeAlternativeTaxonomies

  _formattedNodes: (nodes) ->
    sortedNodes = _.sortBy nodes || [], (node) -> node.name
    _.map sortedNodes, @_formattedNode

  _formattedNode: (node) =>
    text: node.name
    icon: 'fa'
    children: _.union(@_formattedTags(node.tags), @_formattedNodes(node.children))

  _formattedTags: (tags) ->
    sortedTags = _.sortBy tags || [], (tag) -> tag
    _.map sortedTags, @_formattedTag

  _formattedTag: (tag) =>
    state:
      selected: _.contains(@currentTags, tag)
    text: @translator[tag] || tag
    data:
      code: tag
    icon: 'fa fa-tag'

  render: ->
    @$el.html @template
      taxonomiesRepository: @taxonomiesRepository
      alternativeTaxonomies: @includeAlternativeTaxonomies
    @loadAlternativeTaxonomies()
    @renderTree()
    @treeContainer = @$el.find('#tree-container')
    @

  _closeModal: ->
    @trigger 'modal:close'

  _submitSelection: ->
    selectedNodes = @treeContainer.jstree(true).get_selected(true)
    selectedLeaves = _.filter(selectedNodes, (node) -> node.children.length == 0)
    selectedTagsCodes = _.map(selectedLeaves, (leaf) -> leaf.data.code)
    @trigger('selected:tags', selectedTagsCodes)
    @_closeModal()

  renderTree: ->
    @$el.find('#tree-container').on('search.jstree', (e, data) ->
      firstResult = $(@).find('.jstree-search:eq(0)').get(0)
      firstResult.scrollIntoView() if firstResult
    ) # Autoscroll to search results
    .jstree(
      plugins: ["checkbox", "search"]
      search:
        search_method: "jstree_contains" # case-insensitive
      core:
        themes:
          name: "default"
          dots: false
        data: @formattedNodes
    )

  loadAlternativeTaxonomies: ->
    taxonomiesSelector = @$el.find('#taxonomy-select-input')
    taxonomiesSelector.append("<option id='loading-option'>" + I18n.t('monitoring.dashboard.social_content.tag_editor.hierarchy.search')+ "...</option>")
    @taxonomiesRepository.loadAlternativeTaxonomies(() =>
      taxonomiesSelector.html('')
      _.each(@taxonomiesRepository.taxonomiesNames(), (taxonomyName) =>
        taxonomiesSelector.append("<option class='taxonomy'>" + taxonomyName + "</option>")
      )
    )

  onChangeSelectedTaxonomy: (evt) ->
    selectedTaxonomyName = evt.target.value
    taxonomy = @taxonomiesRepository.taxonomyWithName(selectedTaxonomyName)
    @formattedNodes = @formatNodes(taxonomy.get('hierarchy').root.children)
    tree = @$el.find('#tree-container')
    tree.jstree(true).settings.core.data = @formattedNodes
    tree.jstree(true).refresh()

  searchTree: (keyword) ->
    @treeContainer.jstree(true).search keyword
